export default __webpack_public_path__ + "static/media/mainz_s.583adcf9.jpg";